import React, { Component } from "react";
import Logout from "../../assets/logout.svg";
import Back from "../../assets/back.svg";
// import Edit from '../assets/edit.svg'
import Plus from "../../assets/plus.svg";
import EditButton from "../../components/EditButton";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NumericFormat } from "react-number-format";
import CustomButton from "../../components/CustomButton";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../../assets/cancel.svg";
import Tick from "../../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../../components/Paginator";
import filter from "../../assets/filter.png";
import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  ClubAuthorization,
} from "../../static.js";
import "../../App1.css";
import Tooltip from "@mui/material/Tooltip";
import DatePicker, { DateObject } from "react-multi-date-picker";
import moment from "moment-jalaali";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";
import fileExcel from "@iconify/icons-la/file-excel";
import downloadIcon from "@iconify/icons-la/download";

const mobileRegex = RegExp(/09(0[0-9]|1[1-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class CustomerGroups extends Component {
  constructor(props) {
    super(props);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.state = {
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "عنوان",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "از خرید",
          field: "fromPurchase",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تا خرید",
          field: "toPurchase",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "امکان تنزل",
          field: "canDowngrade",
          valueFormatter: this.formatDowngradeContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "fotmatEditCell",
          cellRendererParams: {
            editItem: this.editItem.bind(this),
            reportSpecialCustomer: this.reportSpecialCustomer.bind(this),
          },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        fotmatEditCell: EditButton,
        formatCurrency: this.formatCurrency,
        formatNumber: this.formatNumber,
      },
      ModalShow: false,
      modalType: 0,
      writingProgress: false,
      GNameErrorText: "",
      GNameValue: "",
      activeStatus: true,
      fPurchaseErrorText: "",
      fPurchaseValue: "",
      tPurchaseErrorText: "",
      tPurchaseValue: "",
      downgrade: false,
      dataLoading: true,
      currentPage: 0,
      totalPages: 0,
      ModalShow1: false,
      modal1Loading: false,
      reportColumnDefs: [
        {
          headerName: "نام",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "موبایل",
          field: "phone",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ کل خريد",
          field: "totalPurchase",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تعداد کل خريد",
          field: "countPurchase",
          cellRenderer: "formatNumber",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      reportRowData: [],
      currentPage1: 0,
      totalPages1: 0,
      ModalShow2: false,
      CNameErrorText: "",
      CNameValue: "",
      CPhoneErrorText: "",
      CPhoneValue: "",
      writingProgress1: false,
      currentGroupId: null,
      tableHasFilter: false,
      currentRestaurantId: null,
      priceUnit: "",
      dateValue1: moment().add(-1, "jMonth").format("jYYYY/jMM/jDD"),
      maxDateStart: moment().add(-1, "jDays").format("jYYYY/jMM/jDD"),
      dateValue2: moment().format("jYYYY/jMM/jDD"),
      maxDate: moment().add(0, "jDays").format("jYYYY/jMM/jDD"),
      minDate: null,
      ExcelDateModal: false,
      excelProgress: false,
    };

    this.datepicker1 = React.createRef();
    this.datepicker2 = React.createRef();

    this.tableGrid = React.createRef();
    this.tableContainer = React.createRef();
    this.tableContainer1 = React.createRef();

    this.GetAccountGroups = this.GetAccountGroups.bind(this);
    this.textHandleChange = this.textHandleChange.bind(this);
    this.resetModalValues = this.resetModalValues.bind(this);
    this.resetFilterValues = this.resetFilterValues.bind(this);
    this.getBusinessInfo = this.getBusinessInfo.bind(this);
  }

  formatNumber(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "0";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" " + this.state.priceUnit}
        />
      );
      //return <div style={{display:'flex',flexDirection:'row'}}><div>ریال&nbsp;</div><NumericFormat style={{fontFamily:'SFUIDisplayBold'}} value={params.value} displayType={'text'} thousandSeparator={true}/></div>
    } catch (error) {
      return "-";
    }
  }

  formatDowngradeContent(params) {
    if (params.value) return "دارد";
    else return "ندارد";
  }

  fotmatEditCell(params) {
    return;
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange1(dateValue) {
    try {
      this.datepicker1.current.closeCalendar();
      this.datepicker2.current.closeCalendar();
    } catch (error) {}
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue1: value, minDate: value });
  }

  dateChange2(dateValue) {
    try {
      this.datepicker1.current.closeCalendar();
      this.datepicker2.current.closeCalendar();
    } catch (error) {}

    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue2: value, minDate: value });
  }

  GetGroupMembersExcel() {
    let date1 = "";
    let date2 = "";

    date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
    date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format("YYYY-MM-DD");

    let filter = new URLSearchParams({
      restaurantId: this.props.match.params.id,
      groupId: this.state.currentGroupId,
      fromDate: date1 + " 00:00:00",
      toDate: date2 + " 23:59:59",
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    this.setState({ excelProgress: true });
    fetch("https://94.101.187.196/api/Report/GetGroupMembersExcel?" + filter, {
      method: "GET",
      headers: { Authorization: jsonString },
    })
      .then((res) => {
        if (res.status !== 200) {
          return res.json();
        }
        return res.body;
      })
      .then((result) => {
        if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return null;
        } else {
          return result;
        }
      })
      .then((stream) => new Response(stream))
      .then((response) => response.blob())
      .then((blob) => {
        if (blob.size === 0) {
          return null;
        }
        return URL.createObjectURL(blob);
      })
      .then((url) => {
        this.setState({ excelProgress: false });
        if (!url) return;
        const link = document.createElement("a");
        link.href = url;
        link.download =
          "SMSReport_" +
          moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          "_" +
          moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          ".xlsx";
        document.body.appendChild(link);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        document.body.removeChild(link);
      })
      .catch((err) => {
        this.setState({ excelProgress: false });
        console.log(err);
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState(
            {
              currentRestaurantId: result.result[0].id,
              priceUnit: result.result[0].rtlPriceTitle,
            },
            () => {
              this.GetAccountGroups(1);
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
        // console.log("findBusinessWithCode:", result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.getBusinessInfo();
  }

  GetAccountGroups(page) {
    this.setState({ dataLoading: true });
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));
    console.log(data);
    console.log(jsonString);
    fetch(
      "https://94.101.187.196/api/AccountGroup/GetAccountGroups?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          return res.json();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
        this.setState({
          dataLoading: false,
          rowData: result.results[0].items,
          currentPage: result.results[0].currentPage,
          totalPages: result.results[0].totalPages,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  onFirstPageClick() {
    this.GetAccountGroups(1);
  }

  onPreviousPageClick() {
    this.GetAccountGroups(this.state.currentPage - 1);
  }

  onNextPageClick() {
    this.GetAccountGroups(this.state.currentPage + 1);
  }

  onLastPageClick() {
    this.GetAccountGroups(this.state.totalPages);
  }

  onBack() {
    this.props.history.push(
      "/Restaurants/" + this.props.match.params.id + "/Club"
    );
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = this.tableGrid.current.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        // console.log('width',width);
        // console.log('tableContainer',this.tableContainer.current.getBoundingClientRect().width-10);
        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          // console.log('def',def);
          if (def > cols.length) {
            let newwidth = def / cols.length;
            // console.log('newwidth',newwidth)
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            // console.log('aa');
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
        // if (width<this.tableContainer.current.getBoundingClientRect().width) params.api.sizeColumnsToFit()
      }, 50);
    } catch (error) {}
  }

  onFirstDataRendered1(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });
        if (
          width <
          this.tableContainer1.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer1.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  resetModalValues(id) {
    this.setState(
      {
        writingProgress: false,
        GNameErrorText: "",
        GNameValue: "",
        activeStatus: true,
        fPurchaseErrorText: "",
        fPurchaseValue: "",
        tPurchaseErrorText: "",
        tPurchaseValue: "",
        downgrade: false,
      },
      () => {
        this.state.rowData.forEach((element) => {
          if (element.id === id) {
            this.setState({
              GNameValue: element.name,
              activeStatus: element.isActive,
              fPurchaseValue: element.fromPurchase,
              tPurchaseValue: element.toPurchase,
              downgrade: element.canDowngrade,
            });
          }
        });
      }
    );
  }

  onAddNewButton() {
    this.resetModalValues(0);
    this.setState({ ModalShow: true, modalType: 0 });
  }

  editItem(e) {
    this.resetModalValues(e);
    this.setState({ ModalShow: true, modalType: e });
  }

  reportSpecialCustomer(e, name, phone, page) {
    this.setState({ ModalShow1: true, modal1Loading: true });

    let txtFilter = "";
    if (name) txtFilter += "&name=" + name;
    if (phone) txtFilter += "&phone=" + phone;

    let hasFilter = false;
    if (txtFilter) hasFilter = true;

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/Report/GetGroupMembers?restaurantId=" +
        this.state.currentRestaurantId +
        "&groupId=" +
        e +
        "&name=" +
        name +
        "&phone=" +
        phone +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        // if (result.isSuccessfull){

        // }else {
        //     this.props.history.push('/Restaurants');
        // }

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          modal1Loading: false,
          reportRowData: result.results[0].items,
          currentGroupId: e,
          tableHasFilter: hasFilter,
          currentPage1: result.results[0].currentPage,
          totalPages1: result.results[0].totalPages,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ groupListLoading: false });
      });
  }

  onFirstPageClick1() {
    this.reportSpecialCustomer(
      this.state.currentGroupId,
      this.state.CNameValue,
      this.state.CPhoneValue,
      1
    );
  }

  onPreviousPageClick1() {
    this.reportSpecialCustomer(
      this.state.currentGroupId,
      this.state.CNameValue,
      this.state.CPhoneValue,
      this.state.currentPage1 - 1
    );
  }

  onNextPageClick1() {
    this.reportSpecialCustomer(
      this.state.currentGroupId,
      this.state.CNameValue,
      this.state.CPhoneValue,
      this.state.currentPage1 + 1
    );
  }

  onLastPageClick1() {
    this.reportSpecialCustomer(
      this.state.currentGroupId,
      this.state.CNameValue,
      this.state.CPhoneValue,
      this.state.totalPages1
    );
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onConfirm() {
    if (!this.state.GNameValue) {
      this.setState({ GNameErrorText: "نام گروه نمی‌تواند خالی باشد" }, () => {
        toast.error(this.state.GNameErrorText, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
      return;
    } else {
      this.setState({ GNameErrorText: "" });
    }

    if (!this.state.fPurchaseValue) {
      this.setState(
        { fPurchaseErrorText: "ابتدای بازه خرید نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.fPurchaseErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ fPurchaseErrorText: "" });
    }

    if (!this.state.tPurchaseValue) {
      this.setState(
        { tPurchaseErrorText: "انتهای بازه خرید نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.tPurchaseErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ tPurchaseErrorText: "" });
    }

    if (Number(this.state.fPurchaseValue) > Number(this.state.tPurchaseValue)) {
      this.setState(
        {
          fPurchaseErrorText:
            "ابتدای بازه خرید نمی‌تواند از انتهای آن بیشتر باشد",
        },
        () => {
          toast.error(this.state.fPurchaseErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ fPurchaseErrorText: "" });
    }

    let data = [
      {
        restaurantId: Number(this.state.currentRestaurantId),
        id: this.state.modalType,
        name: this.state.GNameValue,
        fromPurchase: Number(this.state.fPurchaseValue),
        toPurchase: Number(this.state.tPurchaseValue),
        isActive: this.state.activeStatus,
        canDowngrade: this.state.downgrade,
      },
    ];

    let data1 = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data1 = Object.assign(data1, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data1));

    console.log(jsonString);
    console.log(data);
    this.setState({ writingProgress: true });
    fetch("https://94.101.187.196/api/AccountGroup/AddOrUpdateAccountGroup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jsonString,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.isSuccessfull) {
          toast.success(
            this.state.modalType === 0
              ? "گروه با موفقیت اضافه شد"
              : "گروه با موفقیت ویرایش شد",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            }
          );
          this.setState({ writingProgress: false, ModalShow: false }, () => {
            this.GetAccountGroups(this.state.currentPage);
          });
        } else if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ writingProgress: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ writingProgress: false });
      });
  }

  hideModal1() {
    this.setState({ ModalShow1: false });
  }

  hideModal2() {
    this.setState({ ModalShow2: false });
  }

  resetFilterValues() {
    this.setState({
      CNameErrorText: "",
      CNameValue: "",
      CPhoneErrorText: "",
      CPhoneValue: "",
    });
  }

  onFilterClick() {
    this.setState({ ModalShow2: true });
  }

  onFilterClear() {
    this.resetFilterValues();
    this.reportSpecialCustomer(this.state.currentGroupId, null, null, 1);
  }

  onCustomerFilterConfirm() {
    if (this.state.CPhoneValue && !mobileRegex.test(this.state.CPhoneValue)) {
      this.setState({ CPhoneErrorText: "شماره موبایل نامعتبر است" }, () => {
        toast.error(this.state.CPhoneErrorText, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
      return;
    } else {
      this.setState({ CPhoneErrorText: "" });
    }

    this.setState({ ModalShow2: false });
    this.reportSpecialCustomer(
      this.state.currentGroupId,
      this.state.CNameValue,
      this.state.CPhoneValue,
      1
    );
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            بازگشت
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
                // data-tip="خروج"
                // data-place="bottom"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">گروه‌بندی مشترکین</div>
          <div className="RestaurantsListSubTitle">
            ایجاد و ویرایش گروه‌های مشترکین
          </div>
        </div>
        <div className="pageContents" ref={this.tableContainer}>
          {!this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              <CustomButton
                title="گروه مشترکین جدید"
                imgHeight={20}
                imgWidth={25}
                flexDirection="row-reverse"
                minHeight="35px"
                img={Plus}
                onClick={this.onAddNewButton.bind(this)}
              />
            </div>
          )}
          {!this.state.dataLoading && (
            <div className="tableContainer ag-theme-alpine">
              <AgGridReact
                enableRtl={true}
                autoHeight={true}
                animateRows={true}
                enableBrowserTooltips={true}
                tooltipMouseTrack={true}
                suppressSizeToFit={false}
                columnDefs={this.state.columnDefs}
                localeText={this.state.gridLocaleText}
                rowData={this.state.rowData}
                suppressDragLeaveHidesColumns={true}
                suppressMovable={true}
                skipHeaderOnAutoSize={false}
                // onGridReady={this.onGridReady.bind(this)}
                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                rowHeight={window.innerWidth <= 587 ? 40 : 50}
                headerHeight={window.innerWidth <= 587 ? 40 : 50}
                frameworkComponents={this.state.frameworkComponents}
                // onRowClicked={this.onGridRowClicked.bind(this)}
                // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                ref={this.tableGrid}
                enableCellTextSelection={true}
                ensureDomOrder={true}
              ></AgGridReact>
            </div>
          )}
          {!this.state.dataLoading && (
            <div
              style={{
                width: "100%",
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Paginator
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                onFirstPageClick={this.onFirstPageClick.bind(this)}
                onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                onNextPageClick={this.onNextPageClick.bind(this)}
                onLastPageClick={this.onLastPageClick.bind(this)}
              />
            </div>
          )}

          {this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WhisperSpinner
                size={50}
                color="var(--brown1)"
                frontColor="var(--brown1)"
                backColor="var(--brown1)"
                loading={true}
              />
            </div>
          )}
        </div>

        <Modal
          show={this.state.ModalShow}
          size="sm"
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">
              {this.state.modalType === 0
                ? "گروه مشترکین جدید"
                : "ویرایش گروه مشترکین"}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div
                className="settingItemContainer"
                style={{ justifyContent: "flex-start" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: "1",
                    marginLeft: "10px",
                    alignItems: "center",
                  }}
                >
                  <div className="settingLabel">نام</div>
                  <Form.Control
                    maxLength="50"
                    className={
                      this.state.GNameErrorText !== ""
                        ? "inputStyleForm inputError textAlignCenter"
                        : "inputStyleForm textAlignCenter"
                    }
                    placeholder="نام گروه"
                    type="text"
                    name="GNameValue"
                    onChange={this.textHandleChange.bind(this)}
                    value={this.state.GNameValue}
                  />
                </div>
                <BootstrapSwitchButton
                  checked={this.state.activeStatus}
                  onChange={(checked) => {
                    this.setState({ activeStatus: checked });
                  }}
                  onlabel="فعال"
                  offlabel="غیرفعال"
                  onstyle="primary"
                  offstyle="warning"
                  width={75}
                />
              </div>
              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  از خرید
                </div>
                <NumericFormat
                  className={
                    this.state.fPurchaseErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  // placeholder="مبلغ"
                  placeholder={this.state.priceUnit}
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  type="text"
                  name="fPurchaseValue"
                  value={this.state.fPurchaseValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                  isNumericString
                  onValueChange={(values) => {
                    this.setState({ fPurchaseValue: values.value });
                  }}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  تا خرید
                </div>
                <NumericFormat
                  className={
                    this.state.tPurchaseErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  // placeholder="مبلغ"
                  placeholder={this.state.priceUnit}
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  type="text"
                  name="tPurchaseValue"
                  value={this.state.tPurchaseValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                  isNumericString
                  onValueChange={(values) => {
                    this.setState({ tPurchaseValue: values.value });
                  }}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel">امکان تنزل به گروه پایین‌تر</div>
                <BootstrapSwitchButton
                  checked={this.state.downgrade}
                  onChange={(checked) => {
                    this.setState({ downgrade: checked });
                  }}
                  onlabel="بله"
                  offlabel="خیر"
                  onstyle="primary"
                  offstyle="warning"
                  width={75}
                />
              </div>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="ذخیره"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirm.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ModalShow1}
          animation={true}
          contentClassName="contanetStyleModal"
          onHide={this.hideModal1.bind(this)}
          centered
        >
          {this.state.modal1Loading && (
            <div
              style={{
                display: "flex",
                width: "90vw",
                maxWidth: "1200px",
                height: "75vh",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WhisperSpinner
                size={50}
                color="var(--brown1)"
                frontColor="var(--brown1)"
                backColor="var(--brown1)"
                loading={true}
              />
            </div>
          )}
          {!this.state.modal1Loading && (
            <div className="RestaurantsListTitle">گزارش مشترکین خاص</div>
          )}

          {!this.state.modal1Loading && (
            <div
              className="pageContents"
              style={{ width: "90vw", height: "auto", alignItems: "center" }}
              ref={this.tableContainer1}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  width: "fit-content",
                  alignSelf: "flex-start",
                }}
              >
                <CustomButton
                  title="اعمال فیلتر"
                  whiteSpace="noWrap"
                  imgHeight={20}
                  imgWidth={25}
                  flexDirection="row-reverse"
                  minHeight="35px"
                  img={filter}
                  onClick={this.onFilterClick.bind(this)}
                />
                <div style={{ minWidth: "10px" }} />
                {this.state.tableHasFilter && (
                  <CustomButton
                    title="حذف فیلترها"
                    whiteSpace="noWrap"
                    imgHeight={20}
                    imgWidth={25}
                    backColor="var(--red1)"
                    flexDirection="row-reverse"
                    minHeight="35px"
                    img={Cancel}
                    onClick={this.onFilterClear.bind(this)}
                  />
                )}
                <div style={{ minWidth: "10px" }} />
                <CustomButton
                  title="خروجی اکسل"
                  whiteSpace="noWrap"
                  imgHeight={20}
                  imgWidth={25}
                  flexDirection="row-reverse"
                  minHeight="35px"
                  ico={fileExcel}
                  onClick={() => {
                    this.setState({ ExcelDateModal: true });
                  }}
                />
              </div>
              <div
                className="tableContainer ag-theme-alpine"
                style={{ minHeight: "65vh", height: "65vh" }}
              >
                <div
                  style={{
                    flex: "1",
                    width: "100%",
                    flexGrow: 1,
                    flexShrink: 0,
                    flexBasis: 0,
                  }}
                >
                  <AgGridReact
                    enableRtl={true}
                    autoHeight={true}
                    animateRows={true}
                    enableBrowserTooltips={true}
                    tooltipMouseTrack={true}
                    suppressSizeToFit={false}
                    columnDefs={this.state.reportColumnDefs}
                    localeText={this.state.gridLocaleText}
                    rowData={this.state.reportRowData}
                    suppressDragLeaveHidesColumns={true}
                    suppressMovable={true}
                    skipHeaderOnAutoSize={false}
                    onFirstDataRendered={this.onFirstDataRendered1.bind(this)}
                    rowHeight={window.innerWidth <= 587 ? 40 : 50}
                    headerHeight={window.innerWidth <= 587 ? 40 : 50}
                    frameworkComponents={this.state.frameworkComponents}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                  ></AgGridReact>
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Paginator
                  currentPage={this.state.currentPage1}
                  totalPages={this.state.totalPages1}
                  onFirstPageClick={this.onFirstPageClick1.bind(this)}
                  onPreviousPageClick={this.onPreviousPageClick1.bind(this)}
                  onNextPageClick={this.onNextPageClick1.bind(this)}
                  onLastPageClick={this.onLastPageClick1.bind(this)}
                />
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "250px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="بستن"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={this.hideModal1.bind(this)}
                  />
                </div>
              </div>
            </div>
          )}
        </Modal>

        <Modal
          show={this.state.ModalShow2}
          size="sm"
          animation={true}
          onHide={this.hideModal2.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">فیلتر مشترکین خاص</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div className="settingLabel">نام</div>
                <Form.Control
                  maxLength="30"
                  className={
                    this.state.CNameErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter"
                      : "inputStyleForm textAlignCenter"
                  }
                  placeholder="نام مشترک"
                  style={{ maxWidth: "120px" }}
                  type="text"
                  name="CNameValue"
                  onChange={this.textHandleChange.bind(this)}
                  value={this.state.CNameValue}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel">موبایل</div>
                <Form.Control
                  maxLength="11"
                  className={
                    this.state.CPhoneErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter"
                      : "inputStyleForm textAlignCenter"
                  }
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  placeholder="موبایل مشترک"
                  type="text"
                  name="CPhoneValue"
                  onChange={this.textHandleChange.bind(this)}
                  value={this.state.CPhoneValue}
                />
              </div>
            </div>

            <div style={{ flex: "1" }} />

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="اعمال فیلتر"
                  loading={this.state.writingProgress1}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onCustomerFilterConfirm.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal2.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ExcelDateModal}
          size="sm"
          animation={true}
          onHide={() => {
            this.setState({ ExcelDateModal: false });
          }}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">انتخاب بازه زمانی</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div className="settingLabel">شروع:</div>
                <DatePicker
                  ref={this.datepicker1}
                  value={this.state.dateValue1}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange1(valuee)}
                  maxDate={this.state.maxDateStart}
                  editable={false}
                  inputMode="none"
                  placeholder="شروع"
                />
              </div>
              <div className="settingItemContainer">
                <div className="settingLabel">پایان:</div>
                <DatePicker
                  ref={this.datepicker2}
                  value={this.state.dateValue2}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange2(valuee)}
                  minDate={this.state.minDate}
                  maxDate={this.state.maxDate}
                  editable={false}
                  inputMode="none"
                  placeholder="پایان"
                />
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="دریافت فایل"
                    loading={this.state.excelProgress}
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    ico={downloadIcon}
                    onClick={this.GetGroupMembersExcel.bind(this)}
                  />
                </div>
                <div style={{ minWidth: "10px" }} />
                <div style={{ flex: "0.8" }}>
                  <CustomButton
                    title="انصراف"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ExcelDateModal: false });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
